import * as React from 'react';
export const playFilledSvg = React.forwardRef(function playFilledSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3 2.247C3 1.061 4.313.344 5.311.986l8.948 5.752a1.5 1.5 0 0 1 0 2.524l-8.948 5.752C4.313 15.656 3 14.94 3 13.753V2.246Z',
    }),
  );
});
playFilledSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var playFilled = {
  category: 'icon',
  colorable: true,
  name: 'playFilled',
  svg: playFilledSvg,
};
